import React from 'react';
import {connect} from 'react-redux';
import store from '../store';
import {Link} from 'react-router-dom';
import {joinGameLocal} from '../actions/matchManagement';
import {joinGameSocket} from '../actions/gameManagement';
import {addToRosterSocket} from '../actions/matchManagement';

export function gameJoin(props){

    function joinRoom(e){
        // Socket
        let payload = {
            gameroom: e.target.value,
            gamertag: store.getState().user.gamertag
        };
        store.dispatch(joinGameSocket(props.socket, payload));
        store.dispatch(addToRosterSocket(props.socket, payload.gameroom, payload.gamertag));
        store.dispatch(joinGameLocal(payload.gameroom));
    }

    let rooms = props.rooms.map((room, index)=>{
        return (
            <Link to="/main/game" key={index}>
                <input
                    type="button"
                    value={room}
                    style={{margin: ".5rem 0 .5rem 0"}}
                    className="btnStretch btnColoring"
                    onClick={e=>{joinRoom(e)}}
                />
            </Link>
        );
    });

    if(!props.roomsExist){
        return(
            <div id="game-join" className="menuWrapper" style={{marginTop: "1rem"}}>
                <h3 style={{textDecoration: "underline"}}>Active Games</h3>
                <div style={{textAlign: "center", marginLeft: "auto", marginRight: "auto"}}>
                    <div id="rooms-active">
                        <h1 style={{padding: "1rem"}}>Sorry, no games are currently running!</h1>
                    </div>
                </div>
            </div>
        );
    }
    else{
        return(
            <div id="game-join" className="menuWrapper">
                <h3 style={{textDecoration: "underline"}}>Active Games</h3>
                <div id="rooms-active">
                    {rooms}
                </div>
            </div>
        );
    }
}

const mapPropsToState = state =>({
    rooms: state.gameMngt.rooms,
    roomsExist: state.gameMngt.roomsExist,
});
export default connect(mapPropsToState)(gameJoin)
export {gameJoin as GameJoinPure};


// WEBPACK FOOTER //
// ./src/comps/gameJoin.js